import type { VoidComponent } from "solid-js";
import { WarningModal } from "../../components/modal/Modal";
import FormVersionRestoreService from "../../services/FormVersionRestoreService";
import { useTranslation } from "../../state/i18n";
import { useModalManager } from "../../components/modal/ModalManager";

const FormVersionRestore: VoidComponent = () => {
  FormVersionRestoreService.init();
  const { t } = useTranslation();
  const { open } = useModalManager();

  if (FormVersionRestoreService.shouldRestore()) {
    open({
      content: () => (
        <WarningModal
          confirmLabel={t(($) => $.FORM_EDITOR_RECOVER_CHANGES_MODAL_CONFIRM_BUTTON)}
          cancelLabel={t(($) => $.FORM_EDITOR_RECOVER_CHANGES_MODAL_DISCARD_BUTTON)}
          title={t(($) => $.FORM_EDITOR_RECOVER_CHANGES_MODAL_TITLE)}
          description={t(($) => $.FORM_EDITOR_RECOVER_CHANGES_MODAL_DESCRIPTION)}
          onConfirm={() => {
            FormVersionRestoreService.restore();
          }}
        />
      ),
      onClose: () => FormVersionRestoreService.reset(),
    });
  }

  return <></>;
};

export default FormVersionRestore;
